// src/components/guides/QuickGuideButton.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, X } from 'lucide-react';
import QuickGuideHub from './QuickGuideHub';

const QuickGuideButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Action Button */}
      <motion.button
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setIsOpen(true)}
        className="fixed bottom-8 left-8 w-14 h-14 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full shadow-lg flex items-center justify-center z-30 group"
        aria-label="Open Storyteller's Handbook"
      >
        <Lightbulb className="w-6 h-6 text-white" />

        {/* Pulse animation */}
        <span className="absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75 animate-ping pointer-events-none"></span>

        {/* Tooltip */}
        <span className="absolute left-16 px-3 py-1 bg-slate-800 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
          Storyteller's Handbook
        </span>
      </motion.button>

      {/* Quick Guide Panel */}
      <QuickGuideHub isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default QuickGuideButton;